import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import CTextBox from '../../../Common/CTextBox';
import { ActionButton, TooltipHost } from '@fluentui/react';
import './style.css';
import { updateBoardContainerTitle } from '../../../../services/sKPI/board.service';
import { action_setBoardContainerTitle } from '../../../../reducers/actions/KPI/actions';
import { useDispatch } from 'react-redux';
import MessageBox from '../../../Common/Message/MessageBox';
import { __MessageTypes } from '../../../../common/Dictionaries';
import { showMessage } from '../../../../common/Helpers';

function CCardTitle(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //Parametros de entrada.
    const { 
        inputParam_CustomTitle = null,
        inputParam_DefaultTitle = null,
        inputParam_ContainerId = null,
        inputParam_EditMode = false,
        inputParam_SetterIsEditTitleMode = null,
    } = props;
    
    //Parametros de componente.
    const [title, setTile] = useState(inputParam_CustomTitle ? inputParam_CustomTitle : inputParam_DefaultTitle)
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    //Funciones de componente.
    const setterTitleValue = (controlValue, textBoxName) => {
        setTile(controlValue)
    }

    //Eventos de componente.
    const onSaveTitle = () => {
        updateBoardContainerTitle(inputParam_ContainerId, title).then((response) => {  
            if (response.data.succeeded) { 
                inputParam_SetterIsEditTitleMode && inputParam_SetterIsEditTitleMode(!inputParam_EditMode)
                dispatch(action_setBoardContainerTitle(inputParam_ContainerId, title))
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch((e) => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const onCancel = () => {
        setTile(inputParam_CustomTitle ? inputParam_CustomTitle : inputParam_DefaultTitle)
        inputParam_SetterIsEditTitleMode && inputParam_SetterIsEditTitleMode(!inputParam_EditMode)
    }

    const excludeFromDragElements = document.querySelectorAll('.excludeFromDrag');

    excludeFromDragElements.forEach(function(element) {
        element.addEventListener('mousedown', function(event) {
            event.stopPropagation();
        });
    });

    //Render de componente.
    return (
        <div>
            {
                !inputParam_EditMode &&
                <b> { title } </b>
            }
            {
                inputParam_EditMode &&
                <div className='d-flex'>
                    <label className='pt-1 pe-2'><b>{t('data-lang-lbl-name')}:</b></label>
                    <CTextBox
                        controlValue={title}
                        setterControlValue={setterTitleValue}
                        className='card-header-textbox excludeFromDrag'
                    />
                    <ActionButton onClick={onSaveTitle} iconProps={{ iconName: 'Save' }} allowDisabledFocus>
                        { t('data-lang-btn-save') }
                    </ActionButton>
                    <ActionButton onClick={onCancel} iconProps={{ iconName: 'Cancel' }} allowDisabledFocus>
                        { t('data-lang-btn-cancel') }
                    </ActionButton>
                    <div style={{position: "absolute", right: 0, paddingRight: '50px'}}>
                        <TooltipHost content={messageConfig.message} >
                            <MessageBox
                                inputParam_Message={ '' }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            />
                        </TooltipHost>
                    </div>
                </div>
            }
        </div>
    );
}
CCardTitle.propTypes = {
    inputParam_DefaultTitle: PropTypes.node.isRequired,
    inputParam_ContainerId: PropTypes.number.isRequired,
    inputParam_CustomTitle: PropTypes.string,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_SetterIsEditTitleMode: PropTypes.func.isRequired,
};
export default CCardTitle;